import React from 'react';
import { SFButton } from 'sfui';
import { HeaderLink } from '../../../Models';
import styles from './LinksBar.module.scss';

export interface LinksBarProps {
  links: HeaderLink[];
}

export const LinksBar = ({
  links
}: LinksBarProps): React.ReactElement<LinksBarProps> => {
  return (
    <ul className={styles.linksBar}>
      {links.map((link: HeaderLink) => (
        <li key={link.label}>
          <SFButton
            variant="text"
            sfColor="grey"
            onClick={() => window.open(link.href, '_blank')}
          >
            {link.label}
          </SFButton>
        </li>
      ))}
    </ul>
  );
};
